import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

export default function Footer() {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about-glowtech-solutions" },
    { name: "Services", href: "/glowtech-services" },
    { name: "Blogs", href: "/glowtech-blogs" },
    { name: "Careers", href: "/glowtech-careers" },
    { name: "Contact", href: "/contact-glowtech-solutions" },
    { name: "Login", href: "/login" },
  ];
  return (
    <footer className="relative bg-[#032842] text-white overflow-hidden">
      {/* Diagonal White Section */}
      <div className="hidden md:block absolute top-0 left-0 h-full w-1/3 z-10">
        <div
          className="h-full w-full bg-white"
          style={{
            clipPath: "polygon(0 -3%, 70% -5%, 90% 100%, 0% 100%)",
          }}
        >
          <div className="px-10 text-[#032842]">
            <img
              src="/logo-with-black-name.png"
              alt="GlowTech Solutions"
              className="w-40 mb-1 "
            />
            <p className="mb-6 text-sm font-medium">
              Innovative solutions for modern businesses.
              <br />
              We create digital experiences that matter.
            </p>
            <div className="flex gap-4 mb-6">
              <a
                href="https://www.facebook.com/profile.php?id=61572863939608"
                target="_blank"
                aria-label="Facebook"
              >
                <FaFacebookF className="text-xl hover:text-blue-600" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                aria-label="Instagram"
              >
                <FaInstagram className="text-xl hover:text-pink-500" />
              </a>
              <a
                href="https://www.youtube.com/@GlowTechSolutions-s8l"
                target="_blank"
                aria-label="YouTube"
              >
                <FaYoutube className="text-xl hover:text-red-500" />
              </a>
            </div>
            <span className="text-sm py-5">
              Plot# E4, 2nd Floor, CMC Enclave Rd Number 1,
              <br />
              near Pearl Village Road, Kondapur, Telangana, 500084
            </span>
          </div>
        </div>
      </div>

      {/* Footer Links Section */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:ml-[33%]">
        {/* Company */}
        <div>
          <h4 className="font-semibold text-lg mb-2">Company</h4>
          <ul className="space-y-1 text-sm">
            {navLinks.map((label) => (
              <li key={label}>
                <a
                  href={`${label.href}`}
                  className="hover:underline text-md"
                >
                  {label.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-semibold text-lg mb-2">Services</h4>
          <ul className="space-y-1 text-sm">
            {[
              {
                label: "Web Development",
                href: "/aI-based-web-development-services",
              },
              {
                label: "App Development",
                href: "/aI-based-app-development-services",
              },
              { label: "Staffing", href: "/aI-integrated-staffing-solutions" },
              { label: "SMS Marketing", href: "/sms-whatsapp-api-solutions" },
              {
                label: "Digital Marketing",
                href: "/glowtech-services",
              },
            ].map(({ label, href }) => (
              <li key={label}>
                <a href={href} className="hover:underline">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Us */}
        <div>
          <h4 className="font-semibold text-lg mb-2">Contact Us</h4>
          <p className="text-sm leading-6">
            Inquiries:{" "}
            <a href="mailto:contact@glowtechsolutions.in" className="underline">
              contact@glowtechsolutions.in
            </a>
            <br />
            Phone: (+91) 788-897-4447
          </p>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="border-t border-white/20 text-center text-sm py-4 px-6 relative z-20">
        © 2025 GlowTech Solutions. All rights reserved.
      </div>
    </footer>
  );
}
